(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  function applyImageTone(card) {
    var source = card.querySelector('img');
    if (!source || card.dataset.asmToneReady === '1') return;
    card.dataset.asmToneReady = '1';

    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        var size = 56;
        canvas.width = size;
        canvas.height = size;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        context.clearRect(0, 0, size, size);
        context.drawImage(image, 0, 0, size, size);
        var pixels = context.getImageData(0, 0, size, size).data;
        var colors = {};
        var winner = null;
        var winnerCount = 0;

        for (var index = 0; index < pixels.length; index += 4) {
          var alpha = pixels[index + 3];
          if (alpha < 210) continue;
          var pixelRed = pixels[index];
          var pixelGreen = pixels[index + 1];
          var pixelBlue = pixels[index + 2];
          var lightness = (pixelRed + pixelGreen + pixelBlue) / 3;
          var spread = Math.max(pixelRed, pixelGreen, pixelBlue) - Math.min(pixelRed, pixelGreen, pixelBlue);
          if (lightness < 165 || spread > 54) continue;

          var redBin = Math.round(pixelRed / 6) * 6;
          var greenBin = Math.round(pixelGreen / 6) * 6;
          var blueBin = Math.round(pixelBlue / 6) * 6;
          var key = redBin + ',' + greenBin + ',' + blueBin;
          colors[key] = (colors[key] || 0) + 1;
          if (colors[key] > winnerCount) {
            winner = [redBin, greenBin, blueBin];
            winnerCount = colors[key];
          }
        }

        if (!winner) return;
        var tone = 'rgb(' + winner[0] + ',' + winner[1] + ',' + winner[2] + ')';
        card.style.setProperty('background-color', tone, 'important');
        source.style.setProperty('background-color', tone, 'important');
        var title = card.querySelector('strong,.asm-category__title,span');
        if (title) title.style.setProperty('background-color', tone, 'important');
      } catch (error) {
        card.dataset.asmToneReady = '0';
      }
    };
    image.src = source.currentSrc || source.src;
  }

  function setCardVisibility(cards, expanded, animate) {
    cards.forEach(function (card, index) {
      if (index < 6) {
        card.style.setProperty('display', 'flex', 'important');
        return;
      }

      if (expanded) {
        card.style.setProperty('display', 'flex', 'important');
        if (animate && card.animate) {
          card.animate(
            [
              { opacity: 0, transform: 'translateY(-8px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            { duration: 280, delay: Math.min((index - 6) * 28, 168), easing: 'ease-out', fill: 'both' }
          );
        }
        return;
      }

      if (animate && card.animate) {
        var closing = card.animate(
          [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(-6px)' }
          ],
          { duration: 190, easing: 'ease-in', fill: 'both' }
        );
        closing.finished.then(function () {
          if (card.closest('.asm-categories') && card.closest('.asm-categories').dataset.asmExpanded !== 'true') {
            card.style.setProperty('display', 'none', 'important');
          }
        }).catch(function () {});
      } else {
        card.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function init() {
    if (!desktop.matches) return;
    var list = document.getElementById('asm-category-list');
    var existingButton = document.querySelector('.asm-categories-toggle');
    if (!list || !existingButton) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll('.asm-category,.asm-categories>a'));
    if (!cards.length) return;

    list.classList.add('asm-desktop-category-grid');
    cards.forEach(applyImageTone);

    var button = existingButton;
    if (button.dataset.asmFinalCategories !== '1') {
      button = existingButton.cloneNode(true);
      existingButton.parentNode.replaceChild(button, existingButton);
      button.dataset.asmFinalCategories = '1';
      button.classList.add('asm-desktop-category-toggle');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var expanded = list.dataset.asmExpanded !== 'true';
        list.dataset.asmExpanded = expanded ? 'true' : 'false';
        list.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var label = button.querySelector('span');
        if (label) label.textContent = expanded ? 'Daha az' : 'Daha çox';
        setCardVisibility(cards, expanded, true);
      }, true);
    }

    list.dataset.asmExpanded = 'false';
    list.classList.remove('is-expanded');
    button.setAttribute('aria-expanded', 'false');
    var label = button.querySelector('span');
    if (label) label.textContent = 'Daha çox';
    button.style.setProperty('display', cards.length > 6 ? 'flex' : 'none', 'important');
    setCardVisibility(cards, false, false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
